import { FeedingPlanType } from '../common'

/** A starter box ships as the first order; the ongoing plan takes over from the second. */
export const FIRST_ORDER_INDEX = 0
export const SECOND_ORDER_INDEX = 1

export const starterBoxPlanTypeFor = (
  ongoing: FeedingPlanType,
  standardCadence: number,
): FeedingPlanType | undefined => {
  if (ongoing === FeedingPlanType.half_bowl) {
    return FeedingPlanType.starter_box_half
  }

  if (ongoing === FeedingPlanType.full_bowl) {
    return standardCadence === 1 ? FeedingPlanType.starter_box_full_1w_over_2w : FeedingPlanType.starter_box
  }

  if (ongoing === FeedingPlanType.topper) {
    return FeedingPlanType.starter_box_topper
  }

  return undefined
}

// Mirrors legacy BaB `getNextMealPlanType` (lyka-ui build-a-box `models/MealPlan.ts`).
const ONGOING_PLAN_TYPE_BY_STARTER = new Map<FeedingPlanType, FeedingPlanType>([
  [FeedingPlanType.starter_box, FeedingPlanType.full_bowl],
  [FeedingPlanType.starter_box_1_week, FeedingPlanType.full_bowl],
  [FeedingPlanType.starter_box_full_1w_over_2w, FeedingPlanType.full_bowl],
  [FeedingPlanType.starter_box_half, FeedingPlanType.half_bowl],
  [FeedingPlanType.starter_box_half_1_week, FeedingPlanType.half_bowl],
  [FeedingPlanType.starter_box_quarter_2_week, FeedingPlanType.half_bowl],
  // Not in the legacy map. The Topper experiment's starter rolls into the Topper Plan.
  [FeedingPlanType.starter_box_topper, FeedingPlanType.topper],
])

/** The ongoing plan a starter box rolls into from the second box onwards. */
export const ongoingPlanTypeFor = (starter: FeedingPlanType): FeedingPlanType | undefined =>
  ONGOING_PLAN_TYPE_BY_STARTER.get(starter)
